import { useSpring, animated } from "react-spring";
import MobileLandingTable from "../../components/MobileLanding/MobileLandingTable";
import { useEffect, useState } from "react";
import { ColumnFiltersState, PaginationState } from "@tanstack/react-table";
import { toast, ToastContainer } from "react-toastify";
import CreatePopupNameAndText from "../../components/ProjectStatusPopup/CreatePopupNameAndText";
import { useGetMobileLandingPagesQuery } from "../../app/services/landing";
import axios from "../../axios";
import { getAuthUser } from "../../app/services/dashboard";
import { endpointUrl } from "../../app/services/api";
import CommonErrorPopup from "../../components/common/CommonErrorPopup";
const MobileLandingPage = () => {

    const props = useSpring({
        to: { opacity: 1 },
        from: { opacity: 0 },
        delay: 1000,
    });
    const [data, setData] = useState<any[]>([]);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);
    const [isLayoutControlOpen, setIsLayoutControlOpen] =
        useState<boolean>(false);
    const [pagination, setPagination] = useState<PaginationState>({
        pageIndex: 0,
        pageSize: 20,
    });
    const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
    const [isEditing, setIsEdit] = useState<boolean>(false);
    const [isSubmit, setIsSubmit] = useState<boolean>(false);
    const [editedData, setEditData] = useState<any>("");
    const [isOpenPopup, setIsOpenPopup] = useState<boolean>(false);
    const [uploading, setUploading] = useState<boolean>(false);
    const [error, setError] = useState<string>("");
    const [isError, setIsError] = useState<boolean>(false);
    const { data: landingData } = useGetMobileLandingPagesQuery();
    useEffect(() => {
        if (landingData) {
            setData(landingData?.data ?? []);
        }
    }, [landingData]);
    const updateLandingData = async (data: any) => {
        const saveData = {
            name_en: data?.name_en ?? '',
            name_tc: data?.name_tc ?? '',
            name_sc: data?.name_sc ?? '',
            link_en: data?.link_en ?? '',
            link_tc: data?.link_tc ? data?.link_tc : data?.link_en,
            link_sc: data?.link_sc ? data?.link_sc : data?.link_en,
            logo: data?.logo,
            id: data?.id,
            order: data?.order,
            key: data?.key,
        };
        const formData = new FormData();
        formData.append('key', saveData.key);
        formData.append('name_en', saveData.name_en ?? '');
        formData.append('name_tc', saveData.name_tc ?? '');
        formData.append('name_sc', saveData.name_sc ?? '');
        formData.append('link_en', saveData.link_en ?? '');
        formData.append('link_tc', saveData.link_tc ?? '');
        formData.append('link_sc', saveData.link_sc ?? '');
        formData.append('_method', 'PUT');
        formData.append('id', saveData.id?.toString());
        formData.append('order', saveData.order);
        if (saveData.logo) {
            formData.append('logo', saveData.logo);
        }
        var getUser = getAuthUser();
        await axios(endpointUrl + "mobile-portal-links/" + saveData.id, {
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${getUser.token}`,
            },
            data: formData,
        })
            .then((payload: any) => {
                if (payload?.status === 200 || payload?.status === 201) {
                    setEditData("");
                    toast("Successfully Saved.", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        type: "success",
                        theme: "light",
                    });

                    setIsSubmit(false);
                    setUploading(false);
                    setData((prev) =>
                        prev.map((item) => {
                            if (item.id === editedData.id) {
                                return {
                                    ...item,
                                    name_en: payload?.data?.data?.name_en,
                                    name_tc: payload?.data?.data?.name_tc,
                                    name_sc: payload?.data?.data?.name_sc,
                                    link_en: payload?.data?.data?.link_en,
                                    link_tc: payload?.data?.data?.link_tc,
                                    link_sc: payload?.data?.data?.link_sc,
                                    logo: payload?.data?.data?.logo,
                                    key: payload?.data?.data?.key,
                                    order: payload?.data?.data?.order,
                                };
                            } else {
                                return item;
                            }
                        })
                    );
                    setIsOpenPopup(false);
                }

            })
            .catch((error) => {
                console.log("error", error)
                setIsError(true);
                setError(error?.response?.data?.message);
                setIsSubmit(false);
                setUploading(false);
                // setIsOpenPopup(false);
            });
    };
    return <div className="px-2 sm:px-4 py-4 bg-white sm:mt-[25px] mt-0 font-poppins text-13 font-semibold text-[#858795] tracking-[-0.03rem] w-full h-full rounded-xl pt-3 pb-8 sm:pt-3 sm:pb-9">
        <CommonErrorPopup message={error} setMessage={setError} setShow={setIsError} show={isError} />
        <animated.div>
            <MobileLandingTable
                data={data}
                setData={setData}
                setIsSuccess={setIsSuccess}
                isSuccess={isSuccess}
                pagination={pagination}
                setPagination={setPagination}
                isLayoutControlOpen={isLayoutControlOpen}
                setIsLayoutControlOpen={setIsLayoutControlOpen}
                globalSearch={''}
                setGlobalSearch={() => 1}
                columnFilters={columnFilters}
                setColumnFilters={setColumnFilters}
                setHiddenFields={1}
                hiddenFields={[]}
                setCurrentView={1}
                setIsEdit={setIsEdit}
                isEditing={isEditing}
                localModuleId={0}
                total={data.length}
                changePage={1}
                setCurrentPage={1}
                currentPage={1}
                setEditData={setEditData}
                setIsOpenPopup={setIsOpenPopup}

            />
        </animated.div>
        <ToastContainer className={"text-12 font-poppins font-normal"} />
        <CreatePopupNameAndText
            isOpen={isOpenPopup}
            setIsOpen={setIsOpenPopup}
            editedData={editedData}
            setEditData={setEditData}
            savePopupData={() => 1}
            updatePopupData={updateLandingData}
            title="Landing Link"
            isSubmit={isSubmit}
            setIsSubmit={setIsSubmit}
            uploading={uploading}
            setUploading={setUploading}
        />

    </div>
}
export default MobileLandingPage;